export enum DeliveryMethods {
    PICKUP = 'pick-up',
    DROPOFF = 'drop-off',
}
